import { createNamespace } from '../../utils'; // Components

import Image from '../../image';
import Loading from '../../loading';

var _createNamespace = createNamespace('prescription'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: {
    detail: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    type: {
      type: Number,
      default: 1
    },
    imgServer: String
  },
  computed: {
    showDoctorSign: function showDoctorSign() {
      var _this$detail = this.detail,
          advisoryType = _this$detail.advisoryType,
          serviceAuditStatus = _this$detail.serviceAuditStatus,
          doctorAuditStatus = _this$detail.doctorAuditStatus; // 直接咨询和图文咨询,客服医生通过审核

      if ((advisoryType === 1 || advisoryType === 2) && serviceAuditStatus === 1) return true; // 视频咨询,医生审核通过

      if (advisoryType === 4 && doctorAuditStatus === 1) return true;
      return false;
    }
  },
  data: function data() {
    return {};
  },
  render: function render() {
    var h = arguments[0];
    var _this$detail2 = this.detail,
        doctorSignUrl = _this$detail2.doctorSignUrl,
        doctorName = _this$detail2.doctorName,
        prescriptionAuditorSignUrl = _this$detail2.prescriptionAuditorSignUrl,
        prescriptionAuditorName = _this$detail2.prescriptionAuditorName,
        dispenserSignature = _this$detail2.dispenserSignature,
        dispatcherSignature = _this$detail2.dispatcherSignature,
        storeContactInfo = _this$detail2.storeContactInfo,
        prescriptionTotalStatus = _this$detail2.prescriptionTotalStatus,
        hospitalSeal = _this$detail2.hospitalSeal,
        pharmacistAuditName = _this$detail2.pharmacistAuditName,
        pharmacistAuditSignUrl = _this$detail2.pharmacistAuditSignUrl,
        validityMemo = _this$detail2.validityMemo,
        showDoctorSign = this.showDoctorSign,
        imgServer = this.imgServer;
    return h("div", {
      "class": bem('check-info')
    }, [h("div", {
      "class": bem('check-info--line')
    }, [h("span", ["\u533B\u5E08:"]), doctorName && showDoctorSign ? h("span", {
      "class": "name"
    }, [doctorName]) : '', doctorSignUrl && showDoctorSign ? h(Image, {
      "attrs": {
        "width": "93px",
        "height": "26.6px",
        "fit": "contain",
        "src": imgServer + doctorSignUrl
      },
      "scopedSlots": {
        loading: function loading() {
          return h(Loading, {
            "attrs": {
              "type": "spinner",
              "size": "20"
            }
          });
        }
      }
    }) : '']), h("div", {
      "class": bem('check-info--line')
    }, [h("span", ["\u836F\u5E08:"]), pharmacistAuditName ? h("span", {
      "class": "name"
    }, [pharmacistAuditName]) : '', pharmacistAuditSignUrl ? h(Image, {
      "attrs": {
        "width": "93px",
        "height": "26.6px",
        "fit": "contain",
        "src": imgServer + pharmacistAuditSignUrl
      },
      "scopedSlots": {
        loading: function loading() {
          return h(Loading, {
            "attrs": {
              "type": "spinner",
              "size": "20"
            }
          });
        }
      }
    }) : '']), h("div", {
      "class": bem('check-info--line')
    }, [h("span", ["\u5BA1\u6838:"]), prescriptionTotalStatus === 2 && prescriptionAuditorName ? h("span", {
      "class": "name"
    }, [prescriptionAuditorName]) : '', prescriptionTotalStatus === 2 && prescriptionAuditorSignUrl ? h(Image, {
      "attrs": {
        "width": "93px",
        "height": "26.6px",
        "fit": "contain",
        "src": imgServer + prescriptionAuditorSignUrl
      },
      "scopedSlots": {
        loading: function loading() {
          return h(Loading, {
            "attrs": {
              "type": "spinner",
              "size": "20"
            }
          });
        }
      }
    }) : '']), h("div", {
      "class": bem('check-info--line')
    }, [h("span", ["\u8C03\u914D:"]), dispenserSignature ? h(Image, {
      "attrs": {
        "width": "93px",
        "height": "26.6px",
        "fit": "contain",
        "src": imgServer + dispenserSignature
      },
      "scopedSlots": {
        loading: function loading() {
          return h(Loading, {
            "attrs": {
              "type": "spinner",
              "size": "20"
            }
          });
        }
      }
    }) : '']), h("div", {
      "class": bem('check-info--line')
    }, [h("span", ["\u6838\u5BF9/\u53D1\u836F:"]), dispatcherSignature ? h(Image, {
      "attrs": {
        "width": "93px",
        "height": "26.6px",
        "fit": "contain",
        "src": imgServer + dispatcherSignature
      },
      "scopedSlots": {
        loading: function loading() {
          return h(Loading, {
            "attrs": {
              "type": "spinner",
              "size": "20"
            }
          });
        }
      }
    }) : '']), h("div", [h("span", ["\u91D1\u989D: "])]), prescriptionTotalStatus === 2 ? h(Image, {
      "class": bem('check-info--seal'),
      "attrs": {
        "width": "100px",
        "height": "100px",
        "fit": "contain",
        "src": hospitalSeal
      },
      "scopedSlots": {
        loading: function loading() {
          return h(Loading, {
            "attrs": {
              "type": "spinner",
              "size": "20"
            }
          });
        }
      }
    }) : '', h("div", {
      "class": bem('check-info--tip')
    }, [h("p", ["\u6CE8: ", validityMemo || '本处方当日生效。', storeContactInfo && storeContactInfo.showStore ? storeContactInfo.showStore : ''])])]);
  }
});